import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Tax";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// Edit Tax
let Id = "";

function Edit({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const typeOpt = [
    { id: 1, title: "Percentage", value: "percentage" },
    { id: 2, title: "Amount", value: "amount" },
  ];

  const fieldArr = [
    { id: 0, title: "Title", name: "name", type: "TextInput" },
    { id: 1, title: "Type", name: "type", type: "Dropdown", options: typeOpt },
    { id: 2, title: "Value", name: "value", type: "TextInput" },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];
  const [fields, setFields] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    value: "",
    status: "",
  });

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.name) {
      error["name"] = "Please enter tax name";
      flag = false;
    }

    if (!fields.value) {
      error["value"] = "Please enter value ";
      flag = false;
    }
    if (!fields.type) {
      error["type"] = "Please select type";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    setErrors({ ...error });
    return flag;
  }

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "TAX");
      if (rightsData?.edit === false) {
        history.push("/dashboard");
      }
    });
    setIsLoader(true);
    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({ url: "tax/list", params: { tax_id: Id } })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setFields(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }, []);

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "tax/update", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/tax");
            toast.success("Record updated successfully");
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.editTax} />
      <AddEditSection
        title="Edit Tax"
        path="/tax"
        fields={fieldArr}
        fieldValue={fields}
        handleChange={handleChange}
        fieldError={errors}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Edit;
